import React from "react";

export default function ApartmentDetails({ apartment }) {
  const apartmentType = apartment.type === "AP" ? "Autopaikka" : "Huoneisto";

  return (
    <div className="mb-3 text-lg">
      <h2 className="font-bold">{`${apartmentType} ${apartment.location.number}`}</h2>
      <dl className="w-full md:w-1/2">
        <div className="flex justify-between">
          <dt>Tyyppi</dt>
          <dd className="font-bold">{apartment.features.roomTypes}</dd>
        </div>
        <div className="flex justify-between">
          <dt>Koko</dt>
          <dd className="font-bold">{apartment.size} m2</dd>
        </div>
        <div className="flex justify-between">
          <dt>Myyntihinta</dt>
          <dd className="font-bold">{apartment.price}</dd>
        </div>
        <div className="flex justify-between">
          <dt>Velaton hinta</dt>
          <dd className="font-bold">{apartment.priceUnencumbered}</dd>
        </div>
      </dl>
    </div>
  );
}
